import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CoordinatesIcon = function CoordinatesIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CoordinatesIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("g", {
      clipPath: "url(#clip0_1194_168495)",
      children: jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M1.864 8a6.136 6.136 0 1 1 12.272 0A6.136 6.136 0 0 1 1.864 8M8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15m1.03 8.53a.2.2 0 0 1-.088.333l-2.87.812a.2.2 0 0 1-.247-.246l.812-2.871a.2.2 0 0 1 .334-.087zm1.084-4.492a1.093 1.093 0 0 1 1.348 1.348l-1.066 3.766c-.102.361-.383.642-.744.744l-3.766 1.066a1.093 1.093 0 0 1-1.348-1.348l1.066-3.766c.102-.361.383-.642.744-.744z",
        clipRule: "evenodd"
      })
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_1194_168495",
        children: jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
};

export { CoordinatesIcon };
